import { render, staticRenderFns } from "./site-contacts.vue?vue&type=template&id=597f7c9e&scoped=true&"
import script from "./site-contacts.vue?vue&type=script&lang=js&"
export * from "./site-contacts.vue?vue&type=script&lang=js&"
import style0 from "./site-contacts.vue?vue&type=style&index=0&id=597f7c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597f7c9e",
  null
  
)

export default component.exports